module.exports = __webpack_public_path__ + "static/media/Registration_Marketplace.619e1900.jpg";